module.exports = __webpack_public_path__ + "img/chiyan.ef4af029.png";